import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Config from '@/config/config'
import HomeDefault from '@/components/pages/home/components/HomeDefault.vue'
import { beforeEachRoute } from '@/router/routerLogic'
import { authPages } from '@/router/pages/auth'
import { devPages } from '@/router/pages/dev'
import { userPages } from '@/router/pages/user'
import { adminPages } from '@/router/pages/admin'
import { programPages } from '@/router/pages/program'
import { adminProgramPages } from '@/router/pages/admin-program'
import { commonPages } from '@/router/pages/common'
import { dictsPages } from '@/router/pages/dicts'
Vue.use(VueRouter)

export const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeDefault,
    redirect: Config.routing.homePage.path,
    children: [
      ...devPages,
      ...authPages,
      ...programPages,
      ...userPages,
      ...adminProgramPages,
      ...adminPages,
      ...commonPages,
      ...dictsPages,
    ],
  },
]

export const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(beforeEachRoute)
